import React from "react";
import { useAppSelector } from "../../../custom-hooks/redux/redux";
import { NotAuthorizedPage } from "../../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";
import AlertLineReportStatusTable from "../../../containers/SystemConfigurationTables/AlertLineReportStatusTable/AlertLineReportStatusTable";

const AlertLineReportStatus = () => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const isAuthorized = currentUserAuthorizations?.canChangeAll || currentUserAuthorizations?.canViewAll;

  return <>{isAuthorized ? <AlertLineReportStatusTable /> : <NotAuthorizedPage />}</>;
};
export default AlertLineReportStatus;
